import * as React from 'react';
import type { SVGProps } from 'react';

const IconCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 7" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.001.886 3.298 6.884 0 3.934l.69-.77 2.607 2.332L9.31.116l.69.77Z"
      fill="currentColor"
    />
  </svg>
);
export default IconCheckMark;
